import _useAsync from 'react-use/lib/useAsync';

const useAsync = _useAsync;

export { useAsync };
//# sourceMappingURL=useAsync.js.map
